module.exports = require("./ar-DZ.js");